"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TimeSlot = function TimeSlot(_ref) {
  var isSelected = _ref.isSelected,
    value = _ref.value,
    onSelect = _ref.onSelect,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_components.SelectionButton, {
    inputType: "radio",
    checked: isSelected,
    onChange: function onChange() {
      return onSelect(value);
    },
    wrapperStyles: className
  }, value.format('h:mma'));
};
TimeSlot.propTypes = {
  onSelect: _propTypes.default.func,
  selected: _propTypes.default.bool,
  value: _propTypes.default.instanceOf(_momentTimezone.default)
};
var _default = TimeSlot;
exports.default = _default;